<script setup lang="ts">
import { AlertCircle, CheckCircle2, Info } from 'lucide-vue-next';

withDefaults(defineProps<{ tone?: 'info' | 'error' | 'success' }>(), { tone: 'info' });
const ICONS = { info: Info, error: AlertCircle, success: CheckCircle2 };
</script>

<template>
  <div class="alert" :class="`alert--${tone}`" :role="tone === 'error' ? 'alert' : 'status'">
    <component
      :is="ICONS[tone]"
      class="alert__icon"
      :size="16"
      :stroke-width="1.75"
      aria-hidden="true"
    />
    <div><slot /></div>
  </div>
</template>
